// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3jT33","item":"PaymentsMobile_item__32eoh","label":"PaymentsMobile_label__17Yxu","amount":"PaymentsMobile_amount__3ddKr"};